import React, { useContext, useEffect, useState } from 'react';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import { DeclaredComponent } from '../DynamicComponent';
import { GlobalStateContext } from '../../context/GlobalStateProvider';
import { Divider } from 'antd';
import { Expression } from '../metadata/Expression';
import { ModelContext } from '../metadata/ModelSource';
import {FormContext, MDForm} from '../metadata/MDForm';
import { ProductInfoContext } from '../data/ApplicationDataSource';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';

const isOdd = (number) => {
  const value = number % 2;
  if (value === 0) {
    return false;
  } else {
    return true;
  }
};

const determineJustifyContent = (index) => {
  if (index === 1) {
    return 'flex-end';
  } else if (index === 2) {
    return 'center';
  } else {
    return 'flex-start';
  }
};

const MobileTable = ({ tableData, currentIndex, labels }) => {

  let styles = {
    column: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignContent: 'center',
      height: '140px',
      padding: '8px 16px',
      backgroundColor: isOdd(currentIndex) ? '#f8f9fa' : '',
    },
  };

  {tableData.map(({ row }, index) => {
      row.map(function(item, index){
          if(item.Field && item.Field.attr === 'Line.UMSUM'){
              styles = {
                  column: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignContent: 'center',
                    height: '180px',
                    padding: '8px 16px',
                    backgroundColor: isOdd(currentIndex) ? '#f8f9fa' : '',
                  },
                };
          }
      });
  })}

  const Label = ({ labels, currentIndex }) => {
    return (
      <Col span={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <DeclaredComponent declaration={labels[currentIndex]} />
      </Col>
    );
  };

  return (
    <div style={styles.column}>
      {tableData.map(({ row }, index) => {
        const currentIndex = index;

        const pdSplit = {Field: {attr: 'Line.PDLimitSplit',dataType: 'SelectUpdate',},};
        const pdSpecial = {Field: {attr: 'Line.PDLimitSpecial',dataType: 'SelectUpdate',},};
        const uimbiPrem = {PremiumSum: {attr: 'Line.UIMBILimit',cd: 'UIMBI',},};
        const hyphen = {Expression: {value: ' / ',},};
        const noUMBI = {Field: {attr: 'Line.NoUMBILimit',dataType: 'SelectUpdate',},};
        const noUMPD = {Field: {attr: 'Line.NoUMPDLimit',dataType: 'SelectUpdate',},};
        const noPIP = {Field: {attr: 'Line.NoPIP',dataType: 'SelectUpdate',},};
        const noReducedbyUMBI = {Field: {attr: 'Line.NoReducedbyUMBIInd',dataType: 'SelectUpdate',},};
        const noAddedPIP = {Field: {attr: 'Line.NoAddedPIP',dataType: 'SelectUpdate',},};
        const noBasicPIP = {Field: {attr: 'Line.NoBasicPIP',dataType: 'SelectUpdate',},};
        const pIPMotorcycles = {Field: {attr: 'Line.PIPMotorcycles',dataType: 'SelectUpdate',},};
        const compDedModernExotic = {Field: {attr: 'Vehicle.ComprehensiveDedModernExotic',dataType: 'SelectUpdate',},};
        const collDedModernExotic = {Field: {attr: 'Vehicle.CollisionDedModernExotic',dataType: 'SelectUpdate',},};
        const compDedExotic = {Field: {attr: 'Vehicle.ComprehensiveDedExotic',dataType: 'SelectUpdate',},};
        const collDedExotic = {Field: {attr: 'Vehicle.CollisionDedExotic',dataType: 'SelectUpdate',},};
        const specialMP = {Field: {attr: 'Line.SpecialMPLimit',dataType: 'SelectUpdate',},};
        const noUIMBI = {Field: {attr: 'Line.NoUIMBILimit',dataType: 'SelectUpdate',},};
        const noMPLimit = {Field: {attr: 'Line.NoMPLimit',dataType: 'SelectUpdate',},};
        const splitUMPD = {Field: {attr: 'Line.SplitUMPDLimit',  component: { UMPDLimitSelector: { attr: 'Line.SplitUMPDLimit', additionalOptions: [], dataType: 'SelectUpdate',  } }, }}

        row.map(function(item, index){
            // UMBI depends on BI
            if(item.Field && item.Field.attr === 'Line.BILimit'){
                item.Field.doOnChange = tableData.setUMBILimitValue;
                if(item.Field.setOtherLimits) {
                  item.Field.doOnChange = function(s){
                      tableData.setUMBILimitValue(s);
                      tableData.setUIMBILimitValue(s);
                  };
                }
            }
            if(item.Field && item.Field.attr === 'Line.UMBILimit'){
                item.Field.newUMBIValue = tableData.newUMBILimitValue;
                // UIMBI depends on UMBI in Kansas and Missouri
                if(item.Field.matchUMBI){
                    item.Field.doOnChange = function(s){
                        tableData.setUMBILimitValue(s);
                        tableData.setUIMBILimitValue(s);
                    };
                }
                else{
                    item.Field.doOnChange = tableData.setUMBILimitValue;
                }
            }
            // UIMBI depends on UMBI in Kansas and Missouri
            if(item.Field && item.Field.attr === 'Line.UIMBILimit' && item.Field.matchUMBI){
                item.Field.newUIMBIValue = tableData.newUIMBILimitValue;
                item.Field.doOnChange = tableData.setUIMBILimitValue;
            }

        });

        return (
          <Row key={index} style={{ display: 'flex', alignItems: 'center' }}>
            {row.map((item, index) => (
              <>
                <Label labels={labels} currentIndex={currentIndex} />
                <Col
                  span={12}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                  key={index}
                >
                  {Object.keys(item)[0] === 'lineLimit' ? (
                    <LineCoverageLimit lineLimitAttr={item.lineLimit}/>
                  ) : (
                    <DeclaredComponent declaration={item} />
                  )}

                  {item.Field && !item.Field.component && item.Field.attr === 'Line.PDLimit' && !item.Field.specialPD ? (
                        <DeclaredComponent declaration={pdSplit} />
                    ) : ( null )}
                    {item.Field && !item.Field.component && item.Field.attr === 'Line.PDLimit' && item.Field.specialPD ? (
                        <>
                        <DeclaredComponent declaration={pdSplit} />
                        <DeclaredComponent declaration={pdSpecial} />
                        </>
                    ) : ( null )}

                    {item.Field && !item.Field.component && item.Field.attr === 'Line.UMBILimit' ? (
                        <DeclaredComponent declaration={noUMBI} />
                    ) : ( null )}
                    {item.Field && !item.Field.component && item.Field.attr === 'Line.ReducedbyUMBIInd' ? (
                       <DeclaredComponent declaration={noReducedbyUMBI} />
                    ) : ( null )}
                    {item.PremiumSum && item.PremiumSum.attr === 'Line.UMBILimit' && !item.PremiumSum.splitLimit ? (
                        <>
                        <DeclaredComponent declaration={hyphen} />
                        <DeclaredComponent declaration={uimbiPrem} />
                        </>
                    ) : ( null )}
                    {item.ConditionalPremiumSum && item.ConditionalPremiumSum.attr === 'Line.UMBILimit' && !item.ConditionalPremiumSum.splitLimit ? (
                        <>
                        <DeclaredComponent declaration={hyphen} />
                        <DeclaredComponent declaration={uimbiPrem} />
                        </>
                    ) : ( null )}
                    {item.Field && item.Field.attr === 'Line.UMPDLimit' && !item.Field.noSplitUMPD ? (
                        <>
                        <DeclaredComponent declaration={splitUMPD} />
                        <DeclaredComponent declaration={noUMPD} />
                        </>
                    ) : ( null )}

                    {item.Field && item.Field.attr === 'Line.PIP' && !item.Field.noPIP ? (
                        <DeclaredComponent declaration={noPIP} />
                    ) : ( null )}

                    {item.Field && item.Field.attr === 'Line.BasicPIP' && !item.Field.noBasicPIP ? (
                        <DeclaredComponent declaration={noBasicPIP} />
                    ) : ( null )}
                    {item.Field && item.Field.attr === 'Line.PIP' && item.Field.pipMotorcycles ? (
                        <DeclaredComponent declaration={pIPMotorcycles} />
                    ) : ( null )}

                    {item.Field && item.Field.attr === 'Line.AddedPIP' ? (
                        <DeclaredComponent declaration={noAddedPIP} />
                    ) : ( null )}

                    {item.Field && item.Field.specialMP && item.Field.attr === 'Line.MPLimit' ? (
                        <DeclaredComponent declaration={specialMP} />
                    ) : ( null )}

                    {item.Field && item.Field.noMPLimit && item.Field.attr === 'Line.MPLimit' ? (
                        <DeclaredComponent declaration={noMPLimit} />
                    ) : ( null )}

                    {item.Field && !item.Field.noModernExotic && item.Field.attr === 'Vehicle.ComprehensiveDed' ? (
                        <DeclaredComponent declaration={compDedModernExotic} />
                    ) : ( null )}
                    {item.Field && !item.Field.noModernExotic && item.Field.attr === 'Vehicle.CollisionDed' ? (
                        <DeclaredComponent declaration={collDedModernExotic} />
                    ) : ( null )}

                    {item.Field && item.Field.noUIMBI && item.Field.attr === 'Line.UIMBILimit' ? (
                        <DeclaredComponent declaration={noUIMBI} />
                    ) : ( null )}

                      {item.PremiumSum && item.PremiumSum.attr === 'Line.UMIBILimit' && !item.PremiumSum.splitLimit ? (
                        <>
                        <DeclaredComponent declaration={hyphen} />
                        <DeclaredComponent declaration={uimbiPrem} />
                        </>
                    ) : ( null )}

                    {item.Field && item.Field.exoticOnly && item.Field.attr === 'Vehicle.ComprehensiveDed' ? (
                        <DeclaredComponent declaration={compDedExotic} />
                    ) : ( null )}
                    {item.Field && item.Field.exoticOnly && item.Field.attr === 'Vehicle.CollisionDed' ? (
                        <DeclaredComponent declaration={collDedExotic} />
                    ) : ( null )}
                </Col>
              </>
            ))}
          </Row>
        );
      })}
    </div>
  );
};

const LineCoverageLimit = ({lineLimitAttr}) => {
  const model = useContext(ModelContext);
  const form = useContext(FormContext);
  const isActive =  model.getValue(`${form.prefix}coverages{coverageCd:${lineLimitAttr}}.status`) === 'Active';
  /*WaiverOfCollision treated differently
    waiver of collision deductible => yes => active => return yes
    waiver of collision deductible => no => deleted => return no
    all other line coverages fall into else
  */
  if(lineLimitAttr === 'WaiverOfCollision'){
    return isActive ? <div>Yes</div> : <div>No</div>
  }
   else{
    if(!isActive){
      return <div>No Coverage</div>
    }

    const limits=  model.getValue(`${form.prefix}coverages{coverageCd:${lineLimitAttr}}.limits`);
    const limitArray = limits && limits.map((limit) => '$' +formatMoneyAmountNoDecimal(limit.value));
    const limitConcat = limitArray && limitArray.join(' / ');
    return <div>{limitConcat}</div>
  }
}

const RowData = ({tableData, prefix}) => {
  return tableData.map(({ row }, index) => {
    const currentIndex = index;
    
    const pdSplit = {Field: {attr: 'Line.PDLimitSplit',dataType: 'SelectUpdate',},};
    const pdSpecial = {Field: {attr: 'Line.PDLimitSpecial',dataType: 'SelectUpdate',},};
    const uimbiPrem = {PremiumSum: {attr: 'Line.UIMBILimit',cd: 'UIMBI',},};
    const hyphen = {Expression: {value: ' / ',},};
	const noUMBI = {Field: {attr: 'Line.NoUMBILimit',dataType: 'SelectUpdate',},};
    const noUMPD = {Field: {attr: 'Line.NoUMPDLimit',dataType: 'SelectUpdate',},};
	const noPIP = {Field: {attr: 'Line.NoPIP',dataType: 'SelectUpdate',},};
	const noReducedbyUMBI = {Field: {attr: 'Line.NoReducedbyUMBIInd',dataType: 'SelectUpdate',},};
	const noAddedPIP = {Field: {attr: 'Line.NoAddedPIP',dataType: 'SelectUpdate',},};
	const noBasicPIP = {Field: {attr: 'Line.NoBasicPIP',dataType: 'SelectUpdate',},};
	const pIPMotorcycles = {Field: {attr: 'Line.PIPMotorcycles',dataType: 'SelectUpdate',},};
    const compDedModernExotic = {Field: {attr: 'Vehicle.ComprehensiveDedModernExotic',dataType: 'SelectUpdate',},};
    const collDedModernExotic = {Field: {attr: 'Vehicle.CollisionDedModernExotic',dataType: 'SelectUpdate',},};
    const compDedExotic = {Field: {attr: 'Vehicle.ComprehensiveDedExotic',dataType: 'SelectUpdate',},};
    const collDedExotic = {Field: {attr: 'Vehicle.CollisionDedExotic',dataType: 'SelectUpdate',},};
    const specialMP = {Field: {attr: 'Line.SpecialMPLimit',dataType: 'SelectUpdate',},};
	const noUIMBI = {Field: {attr: 'Line.NoUIMBILimit',dataType: 'SelectUpdate',},};
	const noMPLimit = {Field: {attr: 'Line.NoMPLimit',dataType: 'SelectUpdate',},};
	const splitUMPD = {Field: {attr: 'Line.SplitUMPDLimit',  component: { UMPDLimitSelector: { attr: 'Line.SplitUMPDLimit', additionalOptions: [], dataType: 'SelectUpdate',  } }, }}
	
	row.map(function(item, index){
		// UMBI depends on BI
		if(item.Field && item.Field.attr === 'Line.BILimit'){
			item.Field.doOnChange = tableData.setUMBILimitValue;
			if(item.Field.setOtherLimits) {
			  item.Field.doOnChange = function(s){
          tableData.setUMBILimitValue(s);
          tableData.setUIMBILimitValue(s);
        };
			}
		}
		if(item.Field && item.Field.attr === 'Line.UMBILimit'){
			item.Field.newUMBIValue = tableData.newUMBILimitValue;
			// UIMBI depends on UMBI in Kansas and Missouri
			if(item.Field.matchUMBI){
				item.Field.doOnChange = function(s){
					tableData.setUMBILimitValue(s);
					tableData.setUIMBILimitValue(s);
				};
			}
			else{
				item.Field.doOnChange = tableData.setUMBILimitValue;
			}
		}

		// UIMBI depends on UMBI in Kansas and Missouri
		if(item.Field && item.Field.attr === 'Line.UIMBILimit' && item.Field.matchUMBI){
			item.Field.newUIMBIValue = tableData.newUIMBILimitValue;
			item.Field.doOnChange = tableData.setUIMBILimitValue;
		}


	});

    return row.map((item, index) => (
        <Col
            key={index}
            span={currentIndex === 2 ? 6 : 9}
            style={{
              display: 'flex',
              alignContent: 'center',
              justifyContent: determineJustifyContent(currentIndex),
            }}
        >
          {Object.keys(item)[0] === 'lineLimit' ? (
            <LineCoverageLimit lineLimitAttr={item.lineLimit}/>
          ) : ( null )}

          {Object.keys(item)[0] === 'PremiumSum' ? (
            <DeclaredComponent declaration={item} prefix={prefix} />
          ) : (
	          <DeclaredComponent declaration={item} />
          )}
          
          {item.Field && !item.Field.component && item.Field.attr === 'Line.PDLimit' && !item.Field.specialPD ? (
              <DeclaredComponent declaration={pdSplit} />
          ) : ( null )}
          {item.Field && !item.Field.component && item.Field.attr === 'Line.PDLimit' && item.Field.specialPD ? (
              <>
              <DeclaredComponent declaration={pdSplit} />
              <DeclaredComponent declaration={pdSpecial} />
              </>
          ) : ( null )}
          
          {item.Field && !item.Field.component && item.Field.attr === 'Line.UMBILimit' ? (
              <DeclaredComponent declaration={noUMBI} />
          ) : ( null )}
          {item.Field && !item.Field.component && item.Field.attr === 'Line.ReducedbyUMBIInd' ? (
             <DeclaredComponent declaration={noReducedbyUMBI} />
          ) : ( null )}
          {item.PremiumSum && item.PremiumSum.attr === 'Line.UMBILimit' && !item.PremiumSum.splitLimit ? (
              <>
              <DeclaredComponent declaration={hyphen} />
              <DeclaredComponent declaration={uimbiPrem} />
              </>
          ) : ( null )}
          {item.ConditionalPremiumSum && item.ConditionalPremiumSum.attr === 'Line.UMBILimit' && !item.ConditionalPremiumSum.splitLimit ? (
              <>
              <DeclaredComponent declaration={hyphen} />
              <DeclaredComponent declaration={uimbiPrem} />
              </>
          ) : ( null )}
          {item.Field && item.Field.attr === 'Line.UMPDLimit' && !item.Field.noSplitUMPD ? (
              <>
              <DeclaredComponent declaration={splitUMPD} />
              <DeclaredComponent declaration={noUMPD} />
              </>
          ) : ( null )}

          {item.Field && item.Field.attr === 'Line.PIP' && !item.Field.noPIP ? (
              <DeclaredComponent declaration={noPIP} />
          ) : ( null )}

          {item.Field && item.Field.attr === 'Line.BasicPIP' && !item.Field.noBasicPIP ? (
              <DeclaredComponent declaration={noBasicPIP} />
          ) : ( null )}
          {item.Field && item.Field.attr === 'Line.PIP' && item.Field.pipMotorcycles ? (
              <DeclaredComponent declaration={pIPMotorcycles} />
          ) : ( null )}

          {item.Field && item.Field.attr === 'Line.AddedPIP' ? (
              <DeclaredComponent declaration={noAddedPIP} />
          ) : ( null )}

          {item.Field && item.Field.specialMP && item.Field.attr === 'Line.MPLimit' ? (
              <DeclaredComponent declaration={specialMP} />
          ) : ( null )}

          {item.Field && item.Field.noMPLimit && item.Field.attr === 'Line.MPLimit' ? (
              <DeclaredComponent declaration={noMPLimit} />
          ) : ( null )}

          {item.Field && !item.Field.noModernExotic && item.Field.attr === 'Vehicle.ComprehensiveDed' ? (
              <DeclaredComponent declaration={compDedModernExotic} />
          ) : ( null )}
          {item.Field && !item.Field.noModernExotic && item.Field.attr === 'Vehicle.CollisionDed' ? (
              <DeclaredComponent declaration={collDedModernExotic} />
          ) : ( null )}
          
          {item.Field && item.Field.noUIMBI && item.Field.attr === 'Line.UIMBILimit' ? (
              <DeclaredComponent declaration={noUIMBI} />
          ) : ( null )}
          
            {item.PremiumSum && item.PremiumSum.attr === 'Line.UMIBILimit' && !item.PremiumSum.splitLimit ? (
              <>
              <DeclaredComponent declaration={hyphen} />
              <DeclaredComponent declaration={uimbiPrem} />
              </>
          ) : ( null )}
          
          {item.Field && item.Field.exoticOnly && item.Field.attr === 'Vehicle.ComprehensiveDed' ? (
              <DeclaredComponent declaration={compDedExotic} />
          ) : ( null )}
          {item.Field && item.Field.exoticOnly && item.Field.attr === 'Vehicle.CollisionDed' ? (
              <DeclaredComponent declaration={collDedExotic} />
          ) : ( null )}
          
        </Col>
    ));
  });
};

const DesktopTable = ({ tableData, prefix }) => {

  return (
    <Row style={{ margin: '16px 0px' }}>
      <RowData tableData={tableData} prefix={prefix}/>
    </Row>
  );
};

const RiskHeader = ({ isDesktop }) => {

  return (
    <Row style={{ marginTop: isDesktop ? '36px' : '' }}>
      <Col span={24}>
        <div className="form-title form-title-margin">
          <Expression
            value={
              '#{Vehicle.ModelYr} #{Vehicle.Manufacturer} #{Vehicle.Model}'
            }
          />
        </div>
      </Col>
      {isDesktop && <Divider />}
    </Row>
  );
};

const ColumnHeaders = ({ isDesktop, labels, isRisk }) => {
  if (!isDesktop) return null;
  if (isRisk) return null;

  const Labels = () => {
    return labels.map((label, index) => (
      <Col
        span={index === 2 ? 6 : 9}
        key={index}
        style={{
          display: 'flex',
          justifyContent: determineJustifyContent(index),
        }}
      >
        <DeclaredComponent declaration={label} style={{ fontWeight: 'bold' }} />
      </Col>
    ));
  };

  return (
    <Row>
      <div style={{ paddingBottom: '8px' }}>
        <Labels />
      </div>
      <Divider />
    </Row>
  );
};

export const InfoTable = ({ content, labels, isRisk, ...props }) => {
  const {prefix} = useContext(FormContext);
  if (!content) return null;
  const { isDesktop } = useContext(GlobalStateContext);
  const { productSetup } = useContext(ProductInfoContext);
  const model = useContext(ModelContext);
  const lineCoverage = (lineCoverages) =>{
    return(
            lineCoverages.map((lineCov,index) => {
              const {tableData} = lineCov
              return table(tableData,index)
            })
    )
  }

  const [newUMBILimitValue, setUMBILimitValue] = useState('-1');
  const [newUIMBILimitValue, setUIMBILimitValue] = useState('-1');

  const table = ( tableData, index ) => {
    tableData.newUMBILimitValue = newUMBILimitValue;
    tableData.setUMBILimitValue = setUMBILimitValue;
    tableData.newUIMBILimitValue = newUIMBILimitValue;
    tableData.setUIMBILimitValue = setUIMBILimitValue;
    if (isDesktop) {
      return (
        <div>
          <DesktopTable
            tableData={tableData}
            prefix={prefix}
          />
        </div>
      );
    }
    return (
      <div>
        <MobileTable
          labels={labels}
          tableData={tableData}
          currentIndex={index}
        />
      </div>
    );
  };

  return (
    <div>
      {isRisk && <RiskHeader isDesktop={isDesktop} />}
      <ColumnHeaders isDesktop={isDesktop} labels={labels} isRisk={isRisk} />
      {content &&
        content.map((data, index) => {
          const { tableData, additionalCoverages, lineCoverages } = data;
          if(lineCoverages !== undefined){
              return(lineCoverage(lineCoverages))
          }

          // Return table with coverages that are changeable
          if (tableData !== undefined && additionalCoverages === undefined) {
            return table(tableData, index);
          }

          // Return table with additional coverages that cannot be changed by user
          const model = useContext(ModelContext);

          const allAvailableCoverages = model.getValue(prefix + 'coverages');

          const coveragesToSkip = [
            'BI',
            'PD',
            'MedPay',
            'UMBI',
            'UIMBI',
            'UIMPD',
            'UMC',
            'OTC',
            'COLL',
            'WaiverOfCollision',
            'PIP',
            'CovMP',
            'BasicPIP',
            'AddedPIP',
            'UMPD',
            'BFPB',
            'AFPB',
            'WLB',
            'FEB',
            'ADB',
            'CFPB',
            'EMB',
            'PIPACC',
            'PPI',
            'APDL',
            'UMS',
            'UMC',
            'OBEL',
            'APIP',
            'UMSUM',
            'SuppSpousal',
            'PIPWLR',
            'EME',
            'ONEVAL'
          ];
          const coveragesToMap = allAvailableCoverages ? allAvailableCoverages.filter(
            (currentCoverage) => {
              if (coveragesToSkip.includes(currentCoverage.coverageCd)) {
                return;
              } else {
                return currentCoverage;
              }
            }
          ) : null;

          if (!coveragesToMap) return null;

          const prioritizedCoverages = [
                      'COLLDEDWAIVER',
                      'FTL',
                      ];
          coveragesToMap.sort((a, b) => (prioritizedCoverages.indexOf(a.coverageCd) > prioritizedCoverages.indexOf(b.coverageCd)) ? -1 : 1);

          return (
            <div style={{ marginTop: '-8px' }}>
              {coveragesToMap.map((data, index) => {
                if (data.description == 'Salvage Value Coverage') {
                    const tableData = [
                      {
                        row: [
                          {
                            Expression: {
                              style: {
                                fontWeight: 'bold',
                                paddingTop: 4,
                              },
                              value: data.description,
                            },
                          },
                        ],
                      },
                      {
                        row: [
                          {
                            Expression: {
                              value: '',
                            },
                          },
                        ],
                      },
                      {
                          row: [
                            {
                              Expression: {
                                value: 'Included',
                              },
                            },
                          ],
                        },
                    ];

                    return table(tableData, index);
                }
                const tableData = [
                  {
                    row: [
                      {
                        Expression: {
                          style: {
                            fontWeight: 'bold',
                            paddingTop: 4,
                          },
                          value: data.description,
                        },
                      },
                    ],
                  },
                  {
                    row: [
                      {
                        Expression: {
                          value: '',
                        },
                      },
                    ],
                  },
                  {
                    row: [
                      {
                        MoneyAmount: {
                          style: {
                            fontWeight: 'bold',
                          },
                          value: data.writtenPremiumAmt,
                        },
                      },
                    ],
                  },
                ];

                return table(tableData, index);
              })}
            </div>
          );
        })}
    </div>
  );
};